/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

// Legacy /ask route — redirects to /operator for backward compat.
export default class LegacyAskRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: Transition) {
    let wildcard = (transition.to?.params as Record<string, string>)?.wildcard || '';
    let queryParams = transition.to?.queryParams ?? {};
    if (wildcard) {
      this.router.replaceWith('apps.app.automation.fin-ai-agent.operator.chat', wildcard, {
        queryParams,
      });
    } else {
      this.router.replaceWith('apps.app.automation.fin-ai-agent.operator', { queryParams });
    }
  }
}
